import React from "react";
import "./TagListView.css";
import { TagItem } from "./TagItem";

export const TagListView = ({ list }) => {
  return (
    <div className="tag-list-wrapper my-grid-view">
      {list.map((course) => (
        <TagItem value={course} />
      ))}
    </div>
  );
};

export default TagListView;
